/**
 * Slovenské názvy typov stĺpov.
 *
 * Pridané 2026-09-30. Typ sa v databáze ukladá anglicky (`pole`, `manhole`,
 * `utility_pole`…) a na viacerých miestach sa zobrazoval surový, napríklad
 * „Typ: POLE" v bočnom paneli topológie. Popisky boli inak roztrúsené po
 * komponentoch ako podmienky v JSX — tu sú na jednom mieste.
 */
export const POLE_TYPE_LABELS: Record<string, string> = {
  olt: 'OLT',
  pole: 'Stĺpik',
  manhole: 'Šachta',
  utility_pole: 'Stĺp',
  building: 'Budova',
  splitter_point: 'Bod rozdelenia',
  onu: 'ONU',
};

/** Ikonka k typu — nech je panel čitateľný na prvý pohľad. */
export const POLE_TYPE_ICONS: Record<string, string> = {
  olt: '🏢',
  pole: '📍',
  manhole: '🕳️',
  utility_pole: '🗼',
  building: '🏠',
  splitter_point: '🔀',
  onu: '📡',
};

/** Slovenský názov typu. Neznámy typ vráti tak, ako prišiel — radšej nech je
 *  vidieť surová hodnota než prázdne miesto. */
export const poleTypeLabel = (typ?: string | null): string =>
  (typ && POLE_TYPE_LABELS[typ]) || typ || '—';

export const poleTypeIcon = (typ?: string | null): string =>
  (typ && POLE_TYPE_ICONS[typ]) || '📍';
